/**
 * アイコン選択方法ステップ
 */
import { btnDelay, usePlaySound } from "common/utils";
import I18n from "features/parent/i18n";
import { CreatePlayerState, PlayerIconMethod, PlayerWizardStep } from "../types";

interface PlayerIconMethodStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
  goToStep: (step: PlayerWizardStep) => void;
}

export const PlayerIconMethodStep = ({ updateState, goToStep }: PlayerIconMethodStepProps) => {
  const play = usePlaySound();

  const handleSelectPreset = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.PRESET, icon: "" });
      goToStep(PlayerWizardStep.PRESET_ICON);
    });
  };

  const handleSelectUpload = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.UPLOAD, icon: "" });
      goToStep(PlayerWizardStep.UPLOAD_ICON);
    });
  };

  const handleSelectProfileAI = () => {
    play();
    btnDelay(() => {
      updateState({ iconMethod: PlayerIconMethod.PROFILE_AI, icon: "" });
      goToStep(PlayerWizardStep.PROFILE_AI);
    });
  };

  return (
    <div className="flex-col-el flex-center w-full h-full py-8">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px]">
          {I18n.t("MSG_ICON_SELECT_TITLE_BY_PARENT")}
        </p>
      </div>

      {/* 選択カード - 3択 */}
      <div className="flex-row-el flex-center gap-6">
        {/* プリセットから選ぶ */}
        <div
          onClick={handleSelectPreset}
          className="flex-col-el items-center justify-center w-[200px] h-[200px] rounded-[4px] bg-green-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">grid_view</span>
          <p className="text-body text-[18px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_SYSTEM_BY_PARENT")}
          </p>
        </div>

        {/* アップロード */}
        <div
          onClick={handleSelectUpload}
          className="flex-col-el items-center justify-center w-[200px] h-[200px] rounded-[4px] bg-orange-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3">upload</span>
          <p className="text-body text-[18px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_UPLOAD_BY_PARENT")}
          </p>
        </div>

        {/* プロフィールから作る */}
        <div
          onClick={handleSelectProfileAI}
          className="flex-col-el flex-center w-[200px] h-[200px] rounded-[4px] bg-blue-100 cursor-pointer select-none"
        >
          <span className="material-symbols-outlined !text-5xl text-white mb-3 mt-8">
            auto_awesome
          </span>
          <p className="text-body text-[18px] text-white text-center whitespace-pre-line">
            {I18n.t("MSG_ICON_SELECT_PROFILE_AI_BY_PARENT")}
          </p>
        </div>
      </div>
    </div>
  );
};
